/* eslint-disable no-console */
import { AnalyticsProvider, IdentityPayload, TrackProps } from '../manager';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

export class GTMProvider implements AnalyticsProvider {
  private isInitialized = false;
  private gtmInstance: unknown | null = null;

  init(options: { gtmInstance: unknown; debug?: boolean }): void {
    try {
      if (!options.gtmInstance) {
        console.debug('GTM: No GTM instance provided, skipping initialization');
        return;
      }

      this.gtmInstance = options.gtmInstance;
      this.isInitialized = true;

      if (options.debug) console.debug('GTM initialized successfully');
    } catch (error) {
      console.debug('Failed to initialize GTM:', error);
    }
  }

  identify(_: IdentityPayload): void {
    return;
  }

  track(event: string, properties?: TrackProps): void {
    if (!this.isReady()) return;

    try {
      if (properties?.event) {
        console.error('GTM: properties.event is not supported, ignoring');
        delete properties.event;
      }

      (this.gtmInstance as any)?.push({ event, ...properties });
    } catch (error) {
      console.debug('GTM track failed:', error);
    }
  }

  isReady(): boolean {
    return this.isInitialized && !!this.gtmInstance;
  }
}
